import { render } from "./CloseAccountLiquidation.vue?vue&type=template&id=240d10fb"
import script from "./CloseAccountLiquidation.vue?vue&type=script&lang=js"
export * from "./CloseAccountLiquidation.vue?vue&type=script&lang=js"

import "./CloseAccountLiquidation.vue?vue&type=style&index=0&id=240d10fb&lang=css"

import exportComponent from "C:\\src\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__